import { render, staticRenderFns } from "./RequSmplList.vue?vue&type=template&id=bddb7ac0&scoped=true&"
import script from "./RequSmplList.vue?vue&type=script&lang=js&"
export * from "./RequSmplList.vue?vue&type=script&lang=js&"
import style0 from "./RequSmplList.vue?vue&type=style&index=0&id=bddb7ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb7ac0",
  null
  
)

export default component.exports